import { graphql } from "@/lib/gql/__generated__";

export const Plan_DesignPage_Query = graphql(`
	query Plan_DesignPage($hotelID: ID!, $planID: ID!) {
		plan(hotelID: $hotelID, planID: $planID) {
			id
			planID
			inSale
			isPrivate
			isRequest
			isDayTrip
			name
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			tags
			tagsLocation
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			# articleTitle
		}
	}
`);
